(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery-checker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-checker')) {
    customElements.define('delivery-checker', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('form')?.addEventListener('submit', (event) => {
          event.preventDefault();
          const input = this.querySelector('input');
          const result = this.querySelector('.p-delivery-checker__result');
          const pincode = input?.value.replace(/\D/g, '') || '';

          result.dataset.visible = 'true';
          if (!/^\d{6}$/.test(pincode)) {
            result.dataset.state = 'error';
            result.textContent = 'Please enter a valid 6-digit Indian pincode.';
            return;
          }

          result.dataset.state = 'success';
          const isLocal = pincode.startsWith('751') || pincode.startsWith('753') || [
            '752050', '752054', '752100', '752101', '752102', '752103',
            '754001', '754005', '754006', '754021', '754071', '754100', '754112'
          ].includes(pincode);
          const isEligible = this.dataset.tryBuyEligible === 'true';
          if (isLocal) {
            const now = new Date();
            const timeParts = new Intl.DateTimeFormat('en-IN', {
              timeZone: 'Asia/Kolkata',
              hour: '2-digit',
              minute: '2-digit',
              hourCycle: 'h23'
            }).formatToParts(now);
            const hour = Number(timeParts.find((part) => part.type === 'hour')?.value || 0);
            const minute = Number(timeParts.find((part) => part.type === 'minute')?.value || 0);
            const beforeCutoff = hour >= 10 && hour < 18;
            let deliveryMessage = 'Order now for delivery by 12:00 PM tomorrow.';
            if (hour < 10) deliveryMessage = 'Order now for delivery by 12:00 PM today.';

            if (beforeCutoff) {
              const twoHoursLater = new Date(now.getTime() + (2 * 60 * 60 * 1000));
              const deliveryTime = new Intl.DateTimeFormat('en-IN', {
                timeZone: 'Asia/Kolkata',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
              }).format(twoHoursLater);
              deliveryMessage = `Order now for delivery by ${deliveryTime} today.`;
            }

            if (isEligible) {
              deliveryMessage += ' Free Try & Buy is also available for 3 to 10 eligible items.';
            }
            result.textContent = deliveryMessage;
          } else {
            result.textContent = 'Standard delivery is available. Express delivery and Try & Buy are currently offered at eligible Bhubaneswar and Cuttack PIN codes.';
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["try-buy-selector"] && !Shopify.designMode) return;
  try {
    class TryBuySelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.addEventListener('change', this.handleChange.bind(this));
      if (this.dataset.feeLineKey && this.dataset.tryBuyAvailable !== 'true') {
        this.removeInvalidFee();
      }
    }

    async removeInvalidFee() {
      this.setAttribute('aria-busy', 'true');
      try {
        await this.request(`${window.Shopify.routes.root}cart/change.js`, { id: this.dataset.feeLineKey, quantity: 0 });
        await this.updateOrderType('Buy Now');
        window.location.reload();
      } catch (error) {
        this.removeAttribute('aria-busy');
      }
    }

    async handleChange(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'attributes[Order type]') return;
      this.setAttribute('aria-busy', 'true');
      const checkoutButtons = document.querySelectorAll('[name="checkout"]');
      checkoutButtons.forEach((button) => button.setAttribute('disabled', ''));

      try {
        if (input.value === 'Try & Buy') {
          if (!this.dataset.feeLineKey) {
            await this.request(`${window.Shopify.routes.root}cart/add.js`, {
              items: [{ id: Number(this.dataset.feeVariantId), quantity: 1, properties: { '_Try & Buy service': 'Yes' } }],
            });
          }
          await this.updateOrderType('Try & Buy');
        } else {
          if (this.dataset.feeLineKey) {
            await this.request(`${window.Shopify.routes.root}cart/change.js`, { id: this.dataset.feeLineKey, quantity: 0 });
          }
          await this.updateOrderType('Buy Now');
        }
        window.location.reload();
      } catch (error) {
        const message = this.querySelector('.try-buy-selector__error');
        message.textContent = this.dataset.errorMessage;
        message.hidden = false;
        this.removeAttribute('aria-busy');
        checkoutButtons.forEach((button) => button.removeAttribute('disabled'));
      }
    }

    updateOrderType(value) {
      return this.request(`${window.Shopify.routes.root}cart/update.js`, { attributes: { 'Order type': value } });
    }

    async request(url, body) {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    }
  }

  if (!customElements.get('try-buy-selector')) {
    customElements.define('try-buy-selector', TryBuySelector);
  }
  } catch(e) { console.error(e); }
})();

})();
